// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-3_8bQ","disabled":"index-disabled-31kax","opacity":"index-opacity-3iJ9l","brightness":"index-brightness-2cOjK"};